import { TierLibrary } from "@/components/admin/TierLibrary";

export function SettingsTiersPage() {
  return <TierLibrary />;
}
